import { DateTime } from 'luxon';

import { Model } from '@app/models/model';

export class User extends Model {
    // Backend fields
    id: number;
    installation: string;
    email_address: string;
    first_name: string;
    last_name: string;
    phone: string;
    status: string;
    type: string;
    signup_datetime: string;
    intercom_id: string;
    plan: {
        entitlement: string;
        expire_datetime: string;
        frequency: string;
        legacy: boolean;
        origin: string;
        price: string;
        subscribed: boolean;
        renews: boolean | number;
        trial: number;
        one_time_purchase: number;
    };

    // Frontend fields
    name: string;
    signup: string;

    constructor(input?: any) {
        super(input);
        this.formatName();
        this.formatSignup();
    }

    formatName() {
        this.name = this.first_name + ' ' + this.last_name;
    }

    formatSignup() {
        this.signup = DateTime.fromISO(this.signup_datetime).toLocaleString(DateTime.DATETIME_MED);
    }
}
